import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              精选评测文章
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              最新最全的黄油评测与选购指南
            </p>
          </div>
          <Link
            to="/category/buying-guide"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 黄油推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500/90 text-white text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime} 分钟阅读
                  </span>
                  <span className="flex items-center gap-1 text-primary-500">
                    <i className="ri-star-fill"></i>
                    {article.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}